import { takeEvery, call, put } from 'redux-saga/effects';
import { get } from 'js-cookie';

import {
  DETAILS_FORM_FACEBOOK_SEND,
  DETAILS_FORM_SEND,
  setSendingAccountForm
} from 'src/app/redux/actions/registration/account/accountForm';
import registerApi from 'src/app/api/registrationApi';
import { firstLetterLowercase, firstLetterUppercase } from 'src/app/api/camelize';
import getSessionId from 'src/app/api/getSessionId';
import getWindowSearchParam from 'src/app/api/getWindowSearchParam';
import { feedbackMessageHide, feedbackMessageShow } from 'src/app/redux/actions/feedbackMessage';
import { apiCommonError } from 'src/app/redux/actions/apiError';
import { EXPERIENCE_STEP, MAILBOX_STEP, setStep, setUserId } from 'src/app/redux/actions/registration/registration';
import { sendStandardRegistrationEvent } from 'src/app/redux/actions/registrationTracker';
import alerts from 'src/app/alerts.json';


const prepareDefaultRegistration = ({ email, password, agreements }) => {
  const emailOriginId = getWindowSearchParam('emailOriginId');
  const returnUrl = getWindowSearchParam('returnUrl');
  const identityId = get('_gpu');
  const sessionId = getSessionId();

  const filteredAgreements = agreements
    .filter(({ checked }) => checked === true)
    .map(({ code }) => ({ code, value: true }));

  return {
    email,
    password,
    emailOriginId,
    identityId,
    sessionId,
    returnUrl,
    agreements: [
      { code: 'terms-of-use', value: true },
      ...filteredAgreements
    ]
  };
};

const prepareFacebookRegistration = ({ agreements }) => {
  const returnUrl = getWindowSearchParam('returnUrl');
  return [
    [ 'returnUrl', returnUrl ],
    [ 'TermsOfUse', true ],
    ...agreements
      .filter(({ checked }) => checked)
      .map(({ code }) => code.split('-'))
      .map((codeParts) => codeParts.map((code) => firstLetterUppercase(code)))
      .map((codeParts) => codeParts.join(''))
      .map((code) => [code, true])
  ]
    .map(row => row.join('='))
    .join('&');
};

const combineRegistrationRequests = (body) => Promise.all(
  [
    registerApi.navigateToNextStep(getWindowSearchParam('emailOriginId')),
    registerApi.registerUser(body)
  ]
)
  .then((responses) => responses.map(firstLetterLowercase))
  .then((responses) => responses.map((response) => response.data))
  .then(([ nextStep, registration ]) => ({ ...nextStep, ...registration }));

function registerUser(prepareRegistrationBody, requests) {
  return function* registerUserGenerator({ payload }) {
    const body = prepareRegistrationBody(payload);

    yield  put(setSendingAccountForm(true));

    function* onSuccess(response) {
      const { path, userId, registrationSourceId, emailOriginId } = response;

      yield put(setSendingAccountForm(false));
      yield put(sendStandardRegistrationEvent({
        mpUserId: userId,
        emailOriginId,
        registrationSourceId
      }));
      yield put(setUserId(userId));

      const lastStep = 'sprawdz-poczte';
      const nextStep = path.includes(lastStep) ? MAILBOX_STEP : EXPERIENCE_STEP;
      yield put(setStep(nextStep));

      return path;
    }

    function* onError({ response }) {
      yield put(setSendingAccountForm(false));
      yield put(apiCommonError(response));

      return response;
    }

    const registerRequestWithDispatchers = yield requests(body)
      .then(onSuccess)
      .catch(onError);

    yield call(() => registerRequestWithDispatchers);
  };
}

function registerFacebook(prepareQueryParams, registrationRequest) {
  return function* registerFacebookGenerator({ payload }) {
    yield put(feedbackMessageHide());

    const facebookParams = prepareQueryParams(payload);

    window.location.assign(registrationRequest(facebookParams));

    yield put(setSendingAccountForm(true));
    yield put(feedbackMessageShow(alerts.facebookRedirection));
  };
}

export default [
  takeEvery(DETAILS_FORM_SEND, registerUser(prepareDefaultRegistration, combineRegistrationRequests)),
  takeEvery(DETAILS_FORM_FACEBOOK_SEND, registerFacebook(prepareFacebookRegistration, registerApi.facebookRegistration))
];
